(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var wrapObserver = null;

  function stripPageFromCollectionUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('page')) return;
      url.searchParams.delete('page');
      var qs = url.searchParams.toString();
      var clean = url.pathname + (qs ? '?' + qs : '') + url.hash;
      history.replaceState(history.state, document.title, clean);
    } catch (e) {}
  }

  function doLoadMore(btn) {
    if (btn.classList.contains('is--loading')) return;

    var href = btn.getAttribute('data-href');
    if (!href) return;

    var ajaxContainer = document.querySelector('[data-ntajax-container]');
    if (!ajaxContainer) return;

    var sectionId = '';
    try {
      var opts = JSON.parse(ajaxContainer.getAttribute('data-ntajax-options') || '{}');
      sectionId = opts.id || '';
    } catch (e) { return; }
    if (!sectionId) return;

    var fetchUrl = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    btn.classList.add('is--loading');

    fetch(fetchUrl, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newContent = doc.querySelector('[data-contentlm-replace]');
        var newWrap = doc.querySelector('[data-wrap-lm]');
        var oldContent = document.querySelector('[data-contentlm-replace]');
        var oldWrap = document.querySelector('[data-wrap-lm]');

        if (newContent && oldContent) {
          // Isotope/Masonry 布局
          var isIsotope = oldContent.classList.contains('isotopet4s');
          if (isIsotope && window.jQuery && window.jQuery.fn.isotopet4s) {
            var $ = window.jQuery;
            var $newItems = $(newContent.innerHTML);
            $(oldContent).isotopet4s('appended', $newItems);
            // 等 Isotope layout 完成后重新初始化商品交互
            if (window.T4SThemeSP && window.T4SThemeSP.reinitProductGridItem) {
              $(oldContent).one('layoutComplete.isotope', function () {
                window.T4SThemeSP.reinitProductGridItem();
              });
            }
          } else {
            oldContent.insertAdjacentHTML('beforeend', newContent.innerHTML);
          }

          // 更新分页包装器
          if (newWrap && oldWrap) {
            oldWrap.innerHTML = newWrap.innerHTML;
          } else if (oldWrap) {
            oldWrap.style.display = 'none';
          }

          // 重新初始化商品卡片交互（Isotope 分支已经在 layoutComplete 中处理了）
          if (!isIsotope && window.T4SThemeSP && window.T4SThemeSP.reinitProductGridItem) {
            setTimeout(function () {
              window.T4SThemeSP.reinitProductGridItem();
            }, 300);
          }
          try { document.body.dispatchEvent(new CustomEvent('t4s:hideTooltip')); } catch (e) {}
        }

        stripPageFromCollectionUrl();
        btn.classList.remove('is--loading');
      })
      .catch(function (err) {
        console.error('[Load More]', err);
        btn.classList.remove('is--loading');
      });
  }

  function bindCollectionScrollLoad() {
    var main = document.querySelector('.t4s-main-collection-page');
    if (!main) return;

    var wrap = main.querySelector('[data-wrap-lm]');
    var btn = wrap && wrap.querySelector('[data-load-more]');

    if (!btn) return;

    // 仅点击加载，不自动滚动加载
    btn.addEventListener('click', function onClick(e) {
      e.stopPropagation();
      doLoadMore(btn);
    });
  }

  function watchLoadMoreWrap() {
    var main = document.querySelector('.t4s-main-collection-page');
    if (!main) return;
    var wrap = main.querySelector('[data-wrap-lm]');
    if (!wrap || wrapObserver) return;

    wrapObserver = new MutationObserver(function () {
      bindCollectionScrollLoad();
    });
    wrapObserver.observe(wrap, { childList: true, subtree: true });
  }

  function init() {
    bindCollectionScrollLoad();
    watchLoadMoreWrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.t4s-main-collection-page')) {
      if (wrapObserver) {
        wrapObserver.disconnect();
        wrapObserver = null;
      }
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
